import { fetchDataFromBackend } from "../api/api";
import { WorkStatusRequestDTO } from "../DTOs/workStatusRequestDTO";
import { approveWorkStatusRequest } from "../redux/slieces/workStatusAppSlice";
import logger from "../core/utils/logger";

const isSimulation= import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";
// Helper to generate fake data

const generateSimulatedRequests = (count = 20) => {
    const statuses = [0, 1, 2]; // e.g. pending, approved, rejected
    const dayStatuses = [0, 1, 2]; // e.g. vacation, sick, remote
    const today = new Date();

    return Array.from({ length: count }).map((_, i) => {
        const start = new Date(today);
        start.setDate(today.getDate() + i);

        const end = new Date(start);
        end.setDate(start.getDate() + 2);

        return new WorkStatusRequestDTO({
            id: i + 1,
            userId: `user-${i + 1}`,
            userName: `Sim User ${i + 1}`,
            email: `user${i + 1}@example.com`,
            organizationId: `org-${(i % 3) + 1}`,
            dateFrom: start.toISOString(),
            dateTo: end.toISOString(),
            dayStatus: dayStatuses[i % dayStatuses.length],
            requestStatus: statuses[i % statuses.length],
        });
    });
};
const simulatedRequests = generateSimulatedRequests(20);
export const WorkStatusAppService = {
    async getWorkStatusRequestsInOrg() {
        try {
            if (isSimulation) {
                logger.log("Simulation mode: returning simulated org work status requests.");
                
                return simulatedRequests;
            }
            const response = await fetchDataFromBackend(`/WorkStatusRequest/GetWorkStatusRequestsInOrg`, {skipAuth: false, method: 'get'});
            logger.log("Work status requests response:", JSON.stringify(response));
            var result = response.map(item=>new WorkStatusRequestDTO(item));
            logger.log("Work status requests Result:", JSON.stringify(result));
            return result;
        } catch (error) {
            logger.error("Error getting work status requests:", error);
            throw error;
        }
    },
    async getWorkStatusRequestByUserId() {
        try {
            if (isSimulation) {
               
                logger.log(`Simulation mode: filtering simulated requests for user ${userId}`);
                return simulatedRequests.filter(r => r.userId === userId);
            }
            const response = await fetchDataFromBackend(`/WorkStatusRequest/GetWorkStatusRequestByUserId`, {skipAuth: false, method: 'get'});
            logger.log("Work status requests response:", JSON.stringify(response));
            var result = response.map(item=>new WorkStatusRequestDTO(item));
            logger.log("Work status requests Result:", JSON.stringify(result));
            return result;
        } catch (error) {
            logger.error("Error getting work status requests:", error);
            throw error;
        }
    },
    async insertWorkStatusRequest(workStatusRequest) {
        try {
            logger.log("Work status request:", JSON.stringify(workStatusRequest));
            if (isSimulation) {
                logger.log("Simulation mode: returning simulated insert result.");
                return new WorkStatusRequestDTO({ ...workStatusRequest, id: Date.now() });
            }
            
            const response = await fetchDataFromBackend(`/WorkStatusRequest/InsertWorkStatusRequest`, {skipAuth: false, method: 'post', data: workStatusRequest});
            var result = new WorkStatusRequestDTO(response);
            return result;
        } catch (error) {
            logger.error("Error inserting work status request:", error);
            throw error;
        }
    },
    async updateWorkStatusRequest(workStatusRequest) {
        try {
            logger.log("Work status request:", JSON.stringify(workStatusRequest));
            if (isSimulation) {
                logger.log("Simulation mode: returning simulated update result.");
                return new WorkStatusRequestDTO(workStatusRequest);
            }
            
            const response = await fetchDataFromBackend(`/WorkStatusRequest/UpdateWorkStatusRequest`, {skipAuth: false, method: 'put', data: workStatusRequest});
            var result = new WorkStatusRequestDTO(response);
            return result;
        } catch (error) {
            logger.error("Error updating work status request:", error);
            throw error;
        }
    },
    async deleteWorkStatusRequest(id) {
        try {
            if (isSimulation) {
                logger.log(`Simulation mode: simulating delete for ID ${id}`);
                return { success: true };
            }
            const response = await fetchDataFromBackend(`/WorkStatusRequest/DeleteWorkStatusRequest?id=${id}`, {
                skipAuth: false,
                method: 'delete'
                
              });
              
            return response;
        } catch (error) {
            logger.error("Error deleting work status request:", error);
            throw error;


}
    },    
 async  approveWorkStatusRequest(id) {
        try {
            if (isSimulation) {
                logger.log(`Simulation mode: simulating approval for ID ${id}`);
                const request = simulatedRequests.find(r => r.id === id) || {};
                return new WorkStatusRequestDTO({ ...request, requestStatus: 2 });
            }
            const response = await fetchDataFromBackend(`/WorkStatusRequest/ApproveWorkStatusRequest?id=${id}`, {
                skipAuth: false,
                method: 'put'
                
              });
              var result = new WorkStatusRequestDTO(response);
            return result;
        } catch (error) {
            logger.error("Error approving work status request:", error);
            throw error;
        }
    },
    async calculateHolidayDays(dateFrom, dateTo) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode: returning simulated holiday calculation.");
                return { suggestedDays: 5, workDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], dateFrom, dateTo };
            }
            const response = await fetchDataFromBackend(
                `/WorkStatusRequest/CalculateHolidayDays?dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`,
                { skipAuth: false, method: 'get' }
            );
            return response;
        } catch (error) {
            logger.error("Error calculating holiday days:", error);
            throw error;
        }
    },
    async rejectWorkStatusRequest(id) {
        try {
            if (isSimulation) {
                logger.log(`Simulation mode: simulating rejection for ID ${id}`);
                const request = simulatedRequests.find(r => r.id === id) || {};
                return new WorkStatusRequestDTO({ ...request, requestStatus: 3 });
            }
            const response = await fetchDataFromBackend(`/WorkStatusRequest/RejectWorkStatusRequest?id=${id}`, {
                skipAuth: false,
                method: 'put'
                
              });
                var result = new WorkStatusRequestDTO(response);
            return result;
        } catch (error) {
            logger.error("Error rejecting work status request:", error);
            throw error;
        }
    }
};